import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import "./HallFameContent.css";
import { hallfameAssets } from "../../imagesData/ImagesData";
import useFetchImageUrls from "../../ConstantUseFetchImageUrls";
import MonthlyLeadersTab from "./MonthlyLeadersTab";
import PersonIcon from "@mui/icons-material/Person";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import CircularProgress from "@mui/material/CircularProgress";
import { getUserData } from "Redux/UserDetails";
import { fetchHallOfFameData } from "Redux/HallOfFame";

function HallFameContent() {
  const query = useMemo(
    () => `params=${encodeURIComponent(JSON.stringify(hallfameAssets))}`,
    [],
  );
  const { imageUrls, error } = useFetchImageUrls(query);

  const [top3MUs, setTop3MUs] = useState([]);

  const userData = useSelector((state) => state.userDetails.userData?.[0]);
  const {
    hallFameData,
    hallFamePerformersData,
    enterpriseIds,
    loading,
    error: loadError,
  } = useSelector((state) => state.hallOfFame);

  const { instance } = useMsal();
  const dispatch = useDispatch();
  const activeAccount = instance.getActiveAccount();
  const enterpriseId = activeAccount?.idTokenClaims?.enterpriseID;

  useEffect(() => {
    if (!enterpriseId) return;
    dispatch(getUserData(enterpriseId));
  }, [enterpriseId, dispatch]);

  const businessUnit = useMemo(
    () => userData?.businessUnit || "Song",
    [userData?.businessUnit],
  );

  useEffect(() => {
    if (!enterpriseId || !businessUnit) return;
    dispatch(fetchHallOfFameData(businessUnit));
  }, [enterpriseId, businessUnit, dispatch]);

  if (error) return <div>Error loading assets.</div>;
  if (!imageUrls || Object.keys(imageUrls).length === 0) return null;

  return (
    <>
      <div className="hallfame-main-container">
        <div className="hallfame-overall-section">
          <div className="hallfame-overall-wrap">
            <div className="hallfame-overall-row row2">
              <div className="hallfame-overall-box">
                <div className="hallfame-performers-wrap">
                  <h3>🏆 Top Hall of fame Performers 🏆</h3>
                  <p className="champ-learn">The Champions of Learning</p>
                  <div className="hallfame-performers-extra-row">
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          padding: "24px",
                        }}
                      >
                        <CircularProgress sx={{ color: "#57008a" }} />
                      </div>
                    ) : loadError ? (
                      <p style={{ margin: 0, color: "#ffffffb0" }}>
                        {loadError}
                      </p>
                    ) : hallFamePerformersData.length === 0 ? (
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          padding: "24px",
                          color: "#ffffffb0",
                          fontSize: "1rem",
                        }}
                      >
                        No learners' data recorded yet
                      </div>
                    ) : (
                      hallFamePerformersData.map((item) => {
                        const MUs = top3MUs.find(
                          (x) => x.enterpriseId === item.enterpriseId,
                        )?.muSmart;

                        return (
                          <div
                            key={item.enterpriseId}
                            className="hallfame-performers-row"
                          >
                            <div className="hallfame-performers-box">
                              {item.photo ? (
                                <img
                                  src={item.photo}
                                  alt={item.name}
                                  className="performer-img"
                                />
                              ) : (
                                <PersonIcon
                                  className="performer-img"
                                  sx={{ fontSize: "4rem" }}
                                />
                              )}

                              <img
                                src={item.medal}
                                alt="medal"
                                className="performer-medal"
                              />

                              <h4>{item.enterpriseId}</h4>

                              <p className="total-points-section">
                                <span>
                                  <CropSquareIcon
                                    sx={{
                                      transform: "rotate(45deg)",
                                      marginRight: "3px",
                                      fontSize: "0.80rem",
                                      color: "#FEA410",
                                    }}
                                  />
                                </span>
                                <span
                                  style={{
                                    color: "#FEA410",
                                    fontWeight: "bolder",
                                    fontSize: "0.95rem",
                                  }}
                                >
                                  {Number(item.totalPoints)}
                                </span>
                              </p>

                              <p>
                                <span>{MUs ?? "-"}</span>
                              </p>

                              <div className="ranking-holder">
                                <img
                                  src={item.ranking}
                                  alt="rank"
                                  className="performer-rank-img"
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="monthly-leaders-section">
          <div className="monthly-leaders-wrap">
            <MonthlyLeadersTab
              enterpriseIds={enterpriseIds}
              onTop3MUs={setTop3MUs}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default HallFameContent;
